import React, { useState, useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import cx from 'classnames';
import { useLocation } from 'react-router-dom';
import { Icon } from '@redturtle/iovisit-theme/components';
import { SearchWidget } from '@plone/volto/components';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  close: { id: 'close-search', defaultMessage: 'Close search' },
  cerca_nel_sito_title: {
    id: 'cerca_nel_sito_title',
    defaultMessage: 'Cerca nel sito',
  },
  searchSite: {
    //serve per fare l'override del placeholder di SearchWidget
    id: 'Search Site',
    defaultMessage: 'Type a keyword...',
  },
});

const HeaderSearch = () => {
  const intl = useIntl();
  const location = useLocation();
  const [viewSearch, setViewSearch] = useState(false);

  const handleESC = (e) => {
    if (e.keyCode === 27) {
      //escape press
      setViewSearch(false);
    }
  };

  useEffect(() => {
    document.body.addEventListener('keydown', handleESC);

    return () => {
      document.body.removeEventListener('keydown', handleESC);
    };
  }, []);

  useEffect(() => {
    setViewSearch(false);
  }, [location]);

  useEffect(() => {
    if (viewSearch) {
      let input = document.querySelector(
        ".searchbox input[name='SearchableText']",
      );
      if (input) {
        input.focus();
      }
    }
  }, [viewSearch]);

  return (
    <div className="iv--header-search">
      <button
        onClick={() => setViewSearch(!viewSearch)}
        className="iv--search-form-open"
        title={intl.formatMessage(messages.cerca_nel_sito_title)}
      >
        <Icon prefix="fas" icon="search" />
      </button>
      <div
        className={cx('iv--search-form-wrapper', {
          open: viewSearch,
        })}
      >
        {viewSearch && (
          <>
            <Container>
              <h2>{intl.formatMessage(messages.cerca_nel_sito_title)}</h2>
              <SearchWidget pathname={location.pathname} />
            </Container>
            <button
              className="iv--search-form-close"
              onClick={() => setViewSearch(false)}
              aria-label={intl.formatMessage(messages.close)}
            >
              <Icon prefix="fas" icon="times" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default HeaderSearch;
